//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { axiosPost } from '../../axios/axios.js'
import TasksGroupProposedTasks from './TasksGroupProposedTasks.vue'
import TaskProposedTasksGroups from './TaskProposedTasksGroups.vue'

export default {
  name: 'TaskSettingsMenu',
  components: {
    TasksGroupProposedTasks: TasksGroupProposedTasks,
    TaskProposedTasksGroups: TaskProposedTasksGroups
  },
  props: {
    taskStatus: {
      type: String,
      default: ''
    },
    group: {
      type: Object,
      default () {
        return null
      }
    },
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    reportRoles: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    menu: function () {
      const buttons = []
      if (this.group == null) {
        if (this.requestRoles.roleDispatcherOrHigher) {
          // buttons.push({
          //   title: 'Создать группу заданий',
          //   key: 'createGroup'
          // })
          // buttons.push({
          //   title: 'Добавить в группу заданий',
          //   key: 'addTaskToGroup'
          // })
        }
        if ((this.reportRoles.roleExecutor || this.reportRoles.roleAdminOrRoot) &&
             this.report.stateId !== 'PR4' && this.request.bpStateId !== 'BS17') {
          buttons.push({
            title: 'Включить в сводный отчёт',
            key: 'includeInMultipleReport'
          })
        }
      } else {
        if (this.requestRoles.roleDispatcherOrHigher) {
          // buttons.push({
          //   title: 'Исключить из группы заданий',
          //   key: 'excludeTaskFromGroup'
          // })
          // buttons.push({
          //   title: 'Редактировать группу заданий',
          //   key: 'editGroup'
          // })
          // buttons.push({
          //   title: 'Удалить группу заданий',
          //   key: 'deleteGroup'
          // })
        }
        if (this.reportRoles.roleExecutor || this.reportRoles.roleAdminOrRoot) {
          buttons.push({
            title: 'Исключить из сводного отчёта',
            key: 'excludeFromMultipleReport'
          })
        }
      }
      return buttons
    }
  },
  methods: {
    onMenuSelect: async function (selection) {
      this.$refs.dropdown.hide()

      if (selection.key === 'createGroup') {
        this.createGroup()
      } else if (selection.key === 'addTaskToGroup') {
        this.addTaskToGroup()
      } else if (selection.key === 'excludeTaskFromGroup') {
        this.excludeTaskFromGroup()
      } else if (selection.key === 'editGroup') {
        this.editGroup()
      } else if (selection.key === 'deleteGroup') {
        this.deleteGroup()
      } else if (selection.key === 'includeInMultipleReport') {
        this.includeInMultipleReport()
      } else if (selection.key === 'excludeFromMultipleReport') {
        this.excludeFromMultipleReport()
      }
    },
    createGroup: function () {
      this.$refs.proposedTasksWindow.select((data) => {
        const formData = new FormData()
        formData.set('groupName', data.groupName)
        formData.set('ids', data.ids.join(','))

        return axiosPost({
          url: '/service/delta/request/group/create',
          data: formData,
          onSuccess: () => {
            this.$emit('task-updated')
          },
          onFailure: 'Ошибка создания группы заданий',
          msgTarget: this,
          throws: true
        })
      })
    },
    addTaskToGroup: function () {
      this.$refs.proposedGroupsWindow.select((data) => {
        const formData = new FormData()
        formData.set('groupId', data.groupId)
        formData.set('ids', this.request.requestId)

        return axiosPost({
          url: '/service/delta/request/group/add',
          data: formData,
          onSuccess: () => {
            this.$emit('task-updated')
          },
          onFailure: 'Ошибка добавления задания в группу',
          msgTarget: this,
          throws: true
        })
      })
    },
    excludeTaskFromGroup: function () {
      const formData = new FormData()
      formData.set('groupId', this.group.id)
      formData.set('ids', this.request.requestId)

      axiosPost({
        url: '/service/delta/request/group/exclude',
        data: formData,
        onSuccess: () => {
          this.$emit('task-updated')
        },
        onFailure: 'Ошибка исключения задания из группы',
        msgTarget: this
      })
    },
    editGroup: function () {
      this.$refs.proposedTasksWindow.select((data) => {
        const formData = new FormData()
        formData.set('groupId', this.group.id)
        formData.set('groupName', data.groupName)
        formData.set('ids', data.ids.join(','))

        return axiosPost({
          url: '/service/delta/request/group/edit',
          data: formData,
          onSuccess: () => {
            this.$emit('task-updated')
          },
          onFailure: 'Ошибка сохранения группы заданий',
          msgTarget: this,
          throws: true
        })
      })
    },
    deleteGroup: function () {
      const formData = new FormData()
      formData.set('groupId', this.group.id)

      axiosPost({
        url: '/service/delta/request/group/delete',
        data: formData,
        onSuccess: () => {
          this.$emit('task-updated')
        },
        onFailure: 'Ошибка удаления группы заданий',
        msgTarget: this
      })
    },
    includeInMultipleReport: function () {
      this.$d_ask({
        callback: (data) => {
          const formData = new FormData()
          formData.set('reportId', this.report.id)

          axiosPost({
            url: '/service/delta/report/multiple/include',
            data: formData,
            onSuccess: () => {
              this.$emit('task-updated')
            },
            onFailure: (error) => {
              this.$q.notify({
                type: 'negative',
                message: 'Ошибка включения отчёта в сводный отчёт. ' + error.message,
                progress: true,
                timeout: 8000
              })
            }
          })
        },
        header: 'Для каждой работы будут установлены последние сохраненные результаты выполнения среди всех отчётов сводного отчёта. Продолжить?'
      })
    },
    excludeFromMultipleReport: function () {
      this.$d_ask({
        callback: (data) => {
          const formData = new FormData()
          formData.set('reportId', this.report.id)

          axiosPost({
            url: '/service/delta/report/multiple/exclude',
            data: formData,
            onSuccess: () => {
              this.$emit('task-updated')
            },
            onFailure: (error) => {
              this.$q.notify({
                type: 'negative',
                message: error.message,
                progress: true,
                timeout: 8000
              })
            }
          })
        },
        header: 'Исключить отчёт из сводного отчёта?'
      })
    }
  }
}
